// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"01e38e4c","703":"9e3edd00"}[chunkId] + ".chunk.js";
};